<template>
  <AppModal :show="showModal" size="sm" unclosable>
    <h3>{{ $t("user.completeRegistration") }}</h3>

    <div class="mb-3">
      <p>{{ $t("user.completeRegistrationText") }}</p>
    </div>

    <SocialCompleteRegistrationForm
      v-if="showModal"
      :disabled="isSaving"
      @submit="onSubmit($event)"
    />
  </AppModal>
</template>

<script setup lang="ts">
import AppModal from "@/components/app-modal.vue";
import SocialCompleteRegistrationForm from "./social-complete-registration-form.vue";
import { ref } from "vue";
import { updateUser } from "@/features/user/store";
import { api } from "@/api";
import { useToast } from "vue-toastification";
import { CompleteRegistrationFormData } from "./models";
import { useI18n } from "vue-i18n";

const { success, error } = useToast();
const { t } = useI18n();

const showModal = ref(false);
const isSaving = ref(false);

const onSubmit = async (data: CompleteRegistrationFormData) => {
  isSaving.value = true;

  try {
    await api.user.completeRegistration(data);
    updateUser({ privacy_policy_agreed: true });

    success("user.completeRegistrationSuccess");
    showModal.value = false;
  } catch (e: any) {
    error(t("apiError.default", { status: e.response?.status }));
  } finally {
    isSaving.value = false;
  }
};

const handleSocialLoginSuccess = ({
  action,
}: {
  action: "login" | "register";
}) => {
  if (action === "register") {
    showModal.value = true;
  }
};

defineExpose({
  handleSocialLoginSuccess,
});
</script>
